import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import pl from '@angular/common/locales/pl';
import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter, withRouterConfig } from '@angular/router';
import {
  ApartmentOutline,
  AppstoreOutline,
  ArrowLeftOutline,
  BankOutline,
  BulbOutline,
  EnvironmentOutline,
  FileAddOutline,
  FileDoneOutline,
  FileSearchOutline,
  FileTextOutline,
  FolderOutline,
  GlobalOutline,
  HistoryOutline,
  HomeOutline,
  IdcardOutline,
  LockOutline,
  MailOutline,
  MedicineBoxOutline,
  MenuFoldOutline,
  NumberOutline,
  PhoneOutline,
  PlusCircleOutline,
  ProfileOutline,
  ReloadOutline,
  SafetyCertificateOutline,
  SaveOutline,
  SettingOutline,
  ShopOutline,
  TagOutline,
  TagsOutline,
  TeamOutline,
  UnorderedListOutline,
  UserAddOutline,
  UserOutline,
} from '@ant-design/icons-angular/icons';
import { provideAuth } from 'angular-auth-oidc-client';
import { pl_PL, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { routes } from './app.routes';
import { authConfig } from './core/authentication/auth.config';
import { authInitializer } from './core/initializers/authInitializer';
import { authInterceptor } from './core/interceptors/authInterceptor';
import { errorInterceptor } from './core/interceptors/errorInterceptor';
import { provideGatewayApiBaseUrl } from './core/providers/gatewayApiBaseUrlProvider';
import { provideInternalApiBaseUrl } from './core/providers/internalApiBaseUrlProvider';

registerLocaleData(pl);
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    provideClientHydration(withEventReplay()),
    provideAuth(authConfig),
    provideAppInitializer(authInitializer()),
    provideNzIcons([
      UserOutline,
      UserAddOutline,
      MailOutline,
      LockOutline,
      PhoneOutline,
      IdcardOutline,
      MedicineBoxOutline,
      SafetyCertificateOutline,
      TeamOutline,
      ApartmentOutline,
      HomeOutline,
      PlusCircleOutline,
      MenuFoldOutline,
      BankOutline,
      ArrowLeftOutline,
      GlobalOutline,
      FolderOutline,
      ShopOutline,
      TagOutline,
      ReloadOutline,
      SaveOutline,
      FileTextOutline,
      EnvironmentOutline,
      ProfileOutline,
      FileSearchOutline,
      FileAddOutline,
      FileDoneOutline,
      HistoryOutline,
      BulbOutline,
      AppstoreOutline,
      NumberOutline,
      UnorderedListOutline,
      SettingOutline,
      TagsOutline,
    ]),
    provideInternalApiBaseUrl(),
    provideGatewayApiBaseUrl(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptor])),
    provideNzI18n(pl_PL),
  ],
};
